(function($){
    
    //Wait for DOM to load completely before building sliders
    //-- Support for Avada live builder
    window.addEventListener('DOMContentLoaded', function() {
        buildSliders();
    });

    function buildSliders() {

        if ( $('.example-slider.swiper').length !== 0 ) {
            const parentWraper      = $('.example-slider-wrapper');
            const fractionCtr       = $('.example-slider-wrapper .swiper-custom-fraction');
            const exampleSlides      = $('.example-slider .swiper-slide');
            const exampleSlideCount  = exampleSlides.length;
            const slideVisibleCount = 3;
            fractionCtr.text( `01 / 0${exampleSlideCount - ( slideVisibleCount - 1 )}` );

            const exampleSwiper = new Swiper('.example-slider.swiper', {
                slidesPerView: "auto",
                loop: false,
                centeredSlides: true,
                centerInsufficientSlides: true,
                spaceBetween: 20,
                pagination: {
                    el: '.example-slider-wrapper .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.example-slider-wrapper .swiper-button-next',
                    prevEl: '.example-slider-wrapper .swiper-button-prev',
                },
                on: {
                    slideChange: () => {

                        if ( $(window).width() <= 768 ) {
                            fractionCtr.text( `${exampleSwiper.realIndex + 1 >= 10 ? '' : '0'}${exampleSwiper.realIndex + 1} 
                                / 
                                ${exampleSlideCount >= 10 ? '' : '0'}${exampleSlideCount}` );
                        } else {
                            fractionCtr.text( `${exampleSwiper.realIndex + 1 >= 10 ? '' : '0'}${exampleSwiper.realIndex + 1} 
                                / 
                                ${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 ) >= 10 ? '' : '0'}${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 )}` );
                        }
                    },
                    transitionStart: () => {
                        parentWraper.find('.example-slider').css({ 'right' : -65 + 'px' });
                    },
                    reachEnd: () => {
        
                        window.setTimeout( function() {
                            parentWraper.find('.example-slider').css({ 'right' : 0 + 'px' });
                        }, 175);
                    }
                },
                breakpoints: {
                    550: {
                        slidesPerView: "auto",
                        spaceBetween: 40,
                    },
                    769: {
                        slidesPerView: 2,
                        centeredSlides: false,
                        spaceBetween: 16,
                    },
                    1330: {
                        slidesPerView: 3,
                        centeredSlides: false,
                        spaceBetween: 16,
                    },
                },
            });

            $(window).on("load resize", function() {

                if ( $(window).width() <= 768 ) {
                    fractionCtr.text( `${exampleSwiper.realIndex + 1 >= 10 ? '' : '0'}${exampleSwiper.realIndex + 1}  
                        / 
                        ${exampleSlideCount >= 10 ? '' : '0'}${exampleSlideCount}` );
                } else {

                    if ( isNaN(exampleSwiper.params.slidesPerView) ) {

                        window.setTimeout( function() {
                            fractionCtr.text( `${exampleSwiper.realIndex + 1 >= 10 ? '' : '0'}${exampleSwiper.realIndex + 1} 
                                / 
                                ${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 ) >= 10 ? '' : '0'}${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 )}` );
                        }, 150);

                    } else {
                        fractionCtr.text( `${exampleSwiper.realIndex + 1 >= 10 ? '' : '0'}${exampleSwiper.realIndex + 1}
                            / 
                            ${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 ) >= 10 ? '' : '0'}${exampleSlideCount - ( exampleSwiper.params.slidesPerView - 1 )}` );
                    }
                }

            });
        }
    }

})(jQuery);